<template>
	<div class="patient-list">
		<span v-if="color === '#913b9c'" @click="$emit('close')" class="close-dark">
			<i :style="{ color: '#fff' }" class="el-icon-close"></i>
		</span>
		<span v-else @click="$emit('close')" class="close-light">
			<i class="el-icon-close"></i>
		</span>
		<div class="message" :style="{ backgroundColor: color }">
			<div class="message-head">
				<span v-if="color === '#913b9c'" :style="{ color: '#fff' }"><b>{{ filteredList.length }}</b> patient{{ filteredList.length > 1 ? 's': ''}}</span>
				<span v-else><b>{{ filteredList.length }}</b> patient{{ filteredList.length > 1 ? 's': ''}}</span>
				<div class="copy-head" @click="copyPatientList">
					<img width="10" src="./image/copy.svg"> Copy Names
				</div>
			</div>
		</div>
		<div class="list-wrapper">
			<el-button class="flag-button" @click="flagNew = true">
				<img src="./image/flag.svg">
				Flag All Patients
			</el-button>
			<template v-for="patient in filteredList">
				<div class="patient-record" :key="patient.id">
						<router-link class="patient" 
						:to="`/patient/${patient.id}/record`"
						target="_blank">
						<div class="profile">
							<span>{{ patient.name }}
								<span v-if="countOccurences(patient.id) > 1">(x{{countOccurences(patient.id)}})</span>
							</span>
						</div>
					</router-link>
					<div :class="['record-content', {resolved : allResolved(patient.problem)}]" v-if="patient.problem.length > 0">
						<el-button circle icon="el-icon-arrow-down" @click="toggleFlag(patient.id)">
						</el-button>
						<span class="flag-badge">
							{{ patient.problem.length }}
							<img v-if="allResolved(patient.problem)" src="./image/flag-green.svg">
							<img v-else src="./image/flag.svg">
						</span>
					</div>
				</div>
				<template v-if="patient.problem.length > 0 && patient.id === flagOpen">
					<div v-for="problem in patient.problem" :key="problem.id" :class="['record-comment', { icon : showIcon(patient.problem)}]">
						<div class="record-flex">
							<img v-if="problem.resolved_time" src="@/module/component/header/image/flag-border-green.svg">
							<img v-else src="@/module/component/header/image/flag-border.svg">
							<span>&ldquo;{{ problem.comment }}&rdquo;</span>
						</div>
						
						<div class="record-response">
							<el-button type="text" @click="openFlagResponse(patient, problem)">See Response</el-button>
						</div>
					</div>
				</template>
			</template>
			
		</div>
		<el-dialog
			:visible.sync="flagNew"
			:append-to-body="true"
			class="send-now-modal flag-modal"
			v-if="flagNew"
			width="40%">
			<div slot="title">
				Add Comment
			</div>
			<div class="question-title">
				{{ question.title || question.question }}
			</div>
			<div class="add-comment">
				<span>Add Comments</span>
				<el-input
					type="textarea"
					:rows="5"
					height="100"
					size="small"
					placeholder="Start typing..."
					:maxlength="50"
					v-model="comment">
				</el-input>
				<span class="char-left">
					{{ 50 - comment.length }} characters left
				</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="flagNew = false" type="text" size="medium">Cancel</el-button>
				<LoadingButton  size="medium" type="primary" 
					@click="markFlagged"
					:disabled="comment.length === 0"
					:loading="flagLoading">Done</LoadingButton>
			</span>
		</el-dialog>
		<el-dialog
			:visible.sync="flagResponseOpen"
			:append-to-body="true"
			 class="send-now-modal flag-modal"
			 v-if="flagResponseOpen"
			 width="40%">
				<div slot="title">
					Response
				</div>
				<div class="question-title">
					{{ question.title || question.question }}
					<div style="font-size:14px;font-weight:400;">{{ showAnswer(question, flagProblem.answer) }}</div>
				</div>
				<div class="flag-detail" style="margin-top: 14px;">
					Comment added by {{ flagProblem.added_name }} on {{ formatDateTime(flagProblem.created) }}
				</div>
				<div class="flag-detail">
					Resolved by {{ flagProblem.resolved_name }} on {{ formatDateTime(flagProblem.resolved_time) }}
				</div>
				<div class="flag-problem">
					{{ flagProblem.comment }}
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="flagResponseOpen = false" type="primary" size="medium">Done</el-button>
				</span>
		</el-dialog>
	</div>
</template>

<script>
import CopyMixin from '@/module/patient/card/chart/mixin/copy.js'
import LoadingButton from '@/module/component/LoadingButton.vue'
import formatDateTime from '@/module/util/format-date-time'
import { displayAnswer } from '@/module/patient/card/chart/generate/questionnaire.js'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-list',

	mixins: [CopyMixin],

	data() {
		return {
			flagNew: false,
			comment: '',
			flagOpen: '',
			flagLoading: false,
			flagResponseOpen: false,
			flagProblem: null
		}
	},

	props: {
		patient: {
			type: Array,
			default: () => ([])
		},
		fullList: {
			type: Array,
			default: () => ([])
		},
		message: {
			type: String
			// default: 'who responded Great on T-3'
		},
        color: {
            type: String,
            default: '#913b9c'
        },
		question: {
			type: Object
		},
		questionnaire: {
			type: String
		}
	},
    methods: {
		...mapActions('outcome', ['addFlagging']),
		formatDateTime,
		displayAnswer,
	    countOccurences(patientId) {
	        let count = 0
	        this.patient.forEach(patient => {
	            if (patient.user === patientId) count++
            })
            return count
        },
		copyPatientList() {
			this.copy(this.filteredList.map(({id, name}) => name + ' (x' + this.countOccurences(id) + ')' ).join('\n'))
		},
		markFlagged() {
			const survey = this.patient.map(({ id }) => id)
			this.flagLoading = true
			this.addFlagging({
				survey,
				comment: this.comment,
				question_id: this.question.id,
				questionnaire: this.questionnaire,
				auth: this.getUser.id
			})
			.then((_) => {
				this.flagLoading = false
				this.flagNew = false
				this.$emit('close')
			})
			.finally((_) => this.flagLoading = false)
		},
		toggleFlag(problemId) {
			if(this.flagOpen === problemId)
				this.flagOpen = ''
			else
				this.flagOpen = problemId
		},
		allResolved(problemList) {
			return problemList.every(({resolved_time}) => resolved_time)
		},
		openFlagResponse(patient, problem) {
			this.flagProblem = problem
			this.flagResponseOpen = true
		},
		getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            if(this.getProviderList) {
                const provider = this.getProviderList.find(({ provider }) => provider === uploaderId)
                if(provider)
                    return provider.name
            }
            return null
        },
		showAnswer(question, answer) {
			if(Array.isArray(answer))
				return answer.map(({value}) => value).join(', ')
			if(question.type === 'multi_question' && Array.isArray(answer.answer))
				return answer.answer[0].answer
			return answer
		},
		showIcon(problemList) {
			return problemList.some(({ resolved_time }) => resolved_time) && problemList.some(({ resolved_time }) => !resolved_time)
		}
    },
	computed: {
		 ...mapGetters('user', [
            'getUser'
        ]),
		...mapGetters('provider', ['getPatientList']),

		filteredList() {
			return this.getPatientList.filter(patient => {
				return this.patient.find(responsePatient => responsePatient.user === patient.id) !== undefined
			})
			.map((patient) => {
				const problem = this.patient
					.filter((responsePatient) => responsePatient.user === patient.id)
					.flatMap((responsePatient) => responsePatient.problem ? responsePatient.problem.map((problem) => ({
						...problem,
						answer : responsePatient.value ? responsePatient.value : 'Not Answered'
						})) : [])
					.filter(({question_id}) => question_id === this.question.id)
				return {
					...patient,
					problem,

				}
			})
			.sort((userA, userB) => userA.name.localeCompare(userB.name))
		}
	},

	components: {
		LoadingButton,
	}
}
</script>

<style lang="scss" scoped>
.patient-list{
	position: fixed;
	top: 50px;
	right: 0;
	height: 100%;
	width: 200px;
	background: #ffffff;
	box-shadow: -3px 0 14px 0 rgba(0, 0, 0, 0.1);
	z-index: 100;
	.message{
        padding-top: 4px;
		color: #333333;
	}
	.message-head{
		font-size: 16px;
		padding: 12px 19px;
	}
	.message-subhead{
		padding: 5px 18px 36px 18px;
		font-size: 12px;
	}
	.copy-head{
		padding-top: 10px;
		font-size: 12px;
		line-height: 15px;
		color: #ffffff;
		cursor: pointer;

		img {
			margin-right: 3px;
			vertical-align: middle;
		}
	}
	.list-wrapper {
		overflow-y: scroll;
		height: calc(100% - 120px);
		.flag-button {
			width: calc(100% - 24px);
			margin: 12px;
			font-size: 14px;
			line-height: 14px;
			color: #000;
			border-color: #cccccc;
			height: 32px;
			padding: 5px;
			img {
				vertical-align: text-top;
			}
		}
	}
	.patient-record {
		display: flex;
		min-height: 45px;
		border-bottom: solid 0.5px #e2e2e2;
		align-items: center;
	}
	.patient{
		display: flex;
		align-items: center;
		transition: 0.2s background-color ease-in;
	}
	.record-content {
		flex-grow: 1;
		display: flex;
		flex-direction: row-reverse;
		margin-right: 10px;
		.flag-badge {
			font-size: 12px;
			background-color: #ffebeb;
			padding: 4px 8px;
			border-radius: 10px;
			display: flex;
			align-items: center;
			img {
				height: 12px;
				padding-left: 4px;
			}
		}
		.el-button.is-circle {
			padding: 0;
			background-color: #ffebeb;
			margin-left: 4px;
			border: none;
			width: 20px;
			height: 20px;
			font-size: 14px;
			padding-top: 3px;
		}
		&.resolved {
			.flag-badge {
				background-color: #E7FFEA;
			}
			.el-button.is-circle  {
				background-color: #E7FFEA;
			}
		}

	}
	.record-comment {
		background-color: #f8f8f8;
		padding: 8px;
		color: #000000;
		border: 1px solid #cccccc;
		font-size: 12px;
		line-height: 16px;
		margin-left: 12px;
		margin-right: 12px;
		margin-top: 12px;
		.record-response {
			text-align: right;
			margin-top: 4px;
			.el-button {
				font-size: 12px;
				color: #3754FF;
				text-decoration: underline;
				padding: 2px;
			}
		}
		.record-flex {
			display: flex;
			align-items: flex-start;
			& > img {
				display: none;
				margin-right: 6px;
			}
		}
		&.icon .record-flex > img {
			display: inline-block;
		}
	}
	.circle{
		margin-left: 16px;
		width: 30px;
		height: 30px;
		border-radius: 100%;
		background-color: #eeeeee;
	}
	.profile{
		font-size: 14px;
		border-bottom: 1px solid;
		color: #333333;
		margin-left: 12px;
		text-decoration: none;
		span {
			border-bottom: none;
		}
	}
	.close-light, .close-dark {
        background: transparent;
		width: 32px;
		height: 32px;
		position: absolute;
		top: 9px;
		right: 9px;
		border-radius: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background-color 0.4s ease;
		i{
			transition: color 0.4s ease;
		}
	}
	.close-light:hover {
		background-color: #fff;
	}
	.close-dark:hover {
		background-color: #fff;
	}
	.close-dark:hover > i {
		color: #000 !important;
	}
	.el-icon-close {
		font-weight: bold;
	}
}

</style>

<style lang="scss">
.flag-modal .el-dialog__body {
	padding: 0px;
	.question-title {
		padding: 16px 20px 14px 20px;
		font-weight: 700;
		font-size: 16px;
		line-height: 18px;
		border-bottom: 1px solid #e2e2e2;
	}
	.flag-problem {
		font-size: 14px;
		line-height: 18px;
		background-color: #EEEEEE;
		padding: 8px;
		margin-top: 6px;
		margin-right: 20px;
		margin-left: 20px;
		word-break: break-word;
	}
	.flag-detail {
		color: #666666;
		font-size: 12px;
		margin-left: 20px;
		margin-top: 5px;
	}
	.add-comment {
		padding: 16px 20px 14px 20px;
		& > span {
			font-size: 12px;
			line-height: 16px;
			display: block;
			margin-bottom: 4px;
		}
		textarea {
			max-height: 105px;
			height: 105px;
			word-break: break-word;
		}
		.char-left {
			display: block;
			margin-top: 4px;
			font-size: 12px;
			line-height: 16px;
			color: #999999;
		}

	}
}
</style>